export default class GeneralInformation {
	productName: string | null;

	scientificName: string | null;

	concentration: string | null;

	pharmaceuticalForm: string | null;

	packSize: string | null;

	companyName: string | null;

	constructor(
		productName: string | null,
		scientificName: string | null,
		concentration: string | null,
		pharmaceuticalForm: string | null,
		packSize: string | null,
		companyName: string | null
	) {
		this.productName = productName;
		this.scientificName = scientificName;
		this.concentration = concentration;
		this.pharmaceuticalForm = pharmaceuticalForm;
		this.packSize = packSize;
		this.companyName = companyName;
	}
}
